<template>
  <section>
    <top-menu/>

    <section>
      <div class="page-content">
        <div class="container-fluid">
          <div class="col-xs-12 col-sm-12 col-md-12 table-box">
            <div class="table-box--header">
              <span class="table-box--header-title">
                <ion-icon name="card-outline"></ion-icon>
                KYC
              </span> <span class="table-box--header-subtitle">
                Gerencie os pedidos de KYC propostos para os usuários
              </span>
              <div class="row">
                <div class="table-box--form">
                  <input-text @contentText="value => dataFilter.companyId = value"
                              @enter-pressed="getContentBenefitsKyc"
                              label="Id da empresa"
                              placeholder="Digite um id" type="text" col="4"/>
                  <input-text @contentText="value => dataFilter.companyName = value"
                              @enter-pressed="getContentBenefitsKyc"
                              label="Nome da empresa"
                              placeholder="Digite um nome" type="text" col="4"/>
                  <input-select @selectedOption="value => dataFilter.status = value"
                                col="2"
                                :options="optionsStatus"
                                label="Status"/>
                  <input-text @contentText="value => dataFilter.employeeId = value"
                              @enter-pressed="getContentBenefitsKyc"
                              label="Id do funcionário"
                              placeholder="Digite um id" type="text" col="4"/>
                  <input-text @contentText="value => dataFilter.employeeName = value"
                              @enter-pressed="getContentBenefitsKyc"
                              label="Nome do funcionário"
                              placeholder="Digite um nome" type="text" col="4"/>
                </div>
                <btn-search @emit-click="getContentBenefitsKyc()" label="Pesquisar"/>
              </div>
            </div>

            <full-loading v-if="loadingBenefitsKyc"/>

            <div v-else class="table-box--content">
              <table v-if="contentBenefitsKyc.length" class="content-table">
                <thead>
                <tr>
                  <th>
                    Nome da empresa
                    <ion-icon id="companyName" v-on:click="orderSort('companyName')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Nome do funcionário
                    <ion-icon id="name" v-on:click="orderSort('name')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Status
                    <ion-icon id="status" v-on:click="orderSort('status')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Criação do pedido
                    <ion-icon id="updatedAt" v-on:click="orderSort('updatedAt')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value, index) in contentBenefitsKyc" :key="index">
                  <td class="content-table--company-name">
                    {{ value.companyName }}
                  </td>
                  <td class="content-table--company-name">
                    {{ value.name }}
                  </td>
                  <td class="content-table--status">
                    <span v-if="value.status === 0" class="unknown">
                      Desconhecido
                    </span> <span v-if="value.status === 1" class="approved">
                      Aprovado
                    </span> <span v-if="value.status === 2" class="analysis">
                      Análise
                    </span> <span v-if="value.status === 3" class="manual-analysis">
                      Análise Manual
                    </span> <span v-if="value.status === 4" class="disapproved">
                      Reprovado
                    </span>
                  </td>
                  <td class="content-table--created">
                    {{ value.updatedAt | formatDate }} <span> às {{ value.updatedAt | formatHors24 }} </span>
                  </td>
                  <td class="content-table--actions">
                    <div class="buttons-actions">
                      <button>
                        <ion-icon name="chevron-forward"></ion-icon>
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>

              <empty-state v-else/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {KYCS_BENEFITS, KYCS_DAYS} from "../../../../urlConfig";
import swal from "sweetalert";
import BtnSearch from "../../components/buttons/btnSearch.vue";
import InputText from "../../components/inputs/inputText.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import EmptyState from "../../components/layouts/emptyState.vue";

export default {
  name: "benefits-kyc",
  components: {
    EmptyState,
    InputSelect,
    BtnSearch,
    InputText,
    topMenu,
    pageHeader,
    fullLoading,
  },
  data() {
    return {
      loadingBenefitsKyc: false,
      contentBenefitsKyc: '',
      optionsStatus: [
        {
          id: '',
          name: 'Selecione'
        },
        {
          id: '0',
          name: 'Desconhecido'
        },
        {
          id: '1',
          name: 'Aprovado'
        },
        {
          id: '2',
          name: 'Análise'
        },
        {
          id: '3',
          name: 'Análise Manual'
        },
        {
          id: '4',
          name: 'Reprovado'
        },
      ],
      dataFilter: {
        companyId: '',
        companyName: '',
        status: '',
        employeeId: '',
        employeeName: '',
      }
    };
  },
  methods: {
    getContentBenefitsKyc() {
      this.loadingBenefitsKyc = true;

      let url = KYCS_BENEFITS + '?filter='

      if (this.dataFilter.companyId)
        url += '&companyId=' + this.dataFilter.companyId
      if (this.dataFilter.companyName)
        url += '&companyName=' + this.dataFilter.companyName
      if (this.dataFilter.status)
        url += '&status=' + this.dataFilter.status
      if (this.dataFilter.employeeId)
        url += '&userId=' + this.dataFilter.employeeId
      if (this.dataFilter.employeeName)
        url += '&userName=' + this.dataFilter.employeeName

      REQUEST_SERVICE.get(url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT KYCS_BENEFITS:", response.data);

          this.contentBenefitsKyc = response.data;

          this.loadingBenefitsKyc = false;
        })
        .catch((reason) => {
          this.loadingBenefitsKyc = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    orderSort(value) {
      $('#updatedAt').css('transform', 'rotate(0deg)');
      $('#status').css('transform', 'rotate(0deg)');
      $('#companyName').css('transform', 'rotate(0deg)');
      $('#name').css('transform', 'rotate(0deg)');

      this.contentBenefitsKyc = this.contentBenefitsKyc.sort(function (a, b) {
        let valueA = a[value];
        let valueB = b[value];
        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase().trim();
        }

        if (typeof valueB === 'string') {
          valueB = valueB.toLowerCase().trim();
        }

        if (valueA > valueB) {
          return 1;
        }
        if (valueA < valueB) {
          return -1;
        }
        return 0;
      });

      if (this[value + 'Order'] === true) {
        this.contentBenefitsKyc.reverse();
        $('#' + value).css('transform', 'rotate(0deg)');
      } else {
        $('#' + value).css('transform', 'rotate(180deg)');
      }

      this[value + 'Order'] = !this[value + 'Order']
    },
  },
  beforeMount() {
    this.getContentBenefitsKyc();
  },
}
</script>

<style lang="scss" scoped>
.container-fluid {
  .table-box {
    padding: 20px 30px;
    background: var(--classic-white);
    border-radius: 10px !important;

    .table-box--header {
      .table-box--header-title {
        display: flex;
        align-items: center;

        font-size: 18px;
        font-weight: 700;
        color: var(--classic-black);

        ion-icon {
          margin-right: 5px;
          font-size: 23px;
          color: var(--dark-gray);
        }
      }

      .table-box--header-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: var(--dark-gray);
      }

      .row {
        margin: 0;
      }

      .table-box--form {
        margin-top: 25px;
      }
    }

    .table-box--content {
      margin-top: 50px;

      .content-table {
        width: 99%;
        max-width: 99%;
        margin-bottom: 20px;

        thead {
          font-size: 14px;
          color: var(--high-gray);
          line-height: 220%;
          padding-bottom: 5px;
          border-bottom: 1px solid var(--classic-gray);

          tr {
            th {
              font-weight: 500 !important;

              ion-icon {
                width: 13px;
                height: 13px;
                transition: .3s;
                cursor: pointer;
              }
            }
          }
        }

        tbody {
          tr {
            border-bottom: 1px solid var(--classic-gray);

            .content-table--company-name {
              width: 28%;
              color: var(--dark-gray);
              padding: 20px 0;

              a {
                display: list-item;
                width: 140px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;

                font-size: 14px;
                font-weight: 500;
                color: var(--high-blue);
                align-items: center;

                ion-icon {
                  font-size: 14px;
                  margin-right: 4px;
                }
              }
            }

            .content-table--status {
              span {
                border-radius: 4px !important;
                font-size: 12px;
                font-weight: 500;
                padding: 4px 16px;
              }

              .unknown {
                color: var(--classic-white);
                background: var(--dark-gray);
                padding: 4px 12px;
              }

              .approved {
                color: var(--classic-white);
                background: var(--light-green);
                padding: 4px 26.5px;
              }

              .analysis {
                color: var(--dark-gray);
                background: var(--light-yellow);
                padding: 4px 33.5px;
              }

              .manual-analysis {
                color: var(--dark-gray);
                background: var(--high-orange);
                padding: 4px 9.5px;
              }

              .disapproved {
                color: var(--classic-white);
                background: var(--light-red);
                padding: 4px 22.7px;
              }
            }

            .content-table--value {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            .content-table--created {
              display: flex;
              flex-direction: column;
              margin-top: 11px;

              font-size: 14px;
              font-weight: 400;
              color: var(--dark-gray);

              span {
                font-size: 12px;
                font-weight: 400;
                color: var(--high-gray);
              }
            }

            .content-table--actions {
              .buttons-actions {
                display: flex;
                flex-direction: row;

                button {
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  background: var(--background-gray);
                  width: 32px;
                  height: 32px;
                  padding: 0;
                  border: none;
                  border-radius: 4px !important;
                  transition: 0.2s;

                  ion-icon {
                    color: var(--dark-gray);
                    font-size: 22px;
                    transition: 0.2s;
                    pointer-events: none;
                  }

                  &:hover {
                    background: var(--high-blue);

                    ion-icon {
                      color: var(--classic-white);
                    }
                  }
                }

                .confirm-payment {
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  background: var(--background-gray);
                  width: 32px;
                  height: 32px;
                  padding: 0;
                  border: none;
                  border-radius: 4px !important;
                  transition: 0.2s;
                  margin-left: 10px;

                  ion-icon {
                    color: var(--dark-gray);
                    font-size: 22px;
                    transition: 0.2s;
                    pointer-events: none;
                  }

                  &:hover {
                    background: var(--light-green);

                    ion-icon {
                      color: var(--classic-white);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/benefits/benefits-kyc.vue